import { v4 as uuidv4 } from 'uuid';
import { MarketingEventsDistributorsGrid } from './MarketingEventsDistributorsGrid';
import { MarketingEventsDistributorsGridPluginSettings } from './MarketingEventsDistributorsGridPluginSettings';
import i18n from '../../../../i18n';

export const MarketingEventsDistributorsTab = (): ITab => {
    const t = (value: string) => i18n.t("sidePanel.directory.submenu." + value);
    return {
        id: uuidv4(),
        title: t("marketingEventsDistributors"),
        view: {
            content: MarketingEventsDistributorsGridPluginSettings
                ? <MarketingEventsDistributorsGrid gridId={uuidv4()} plugin={MarketingEventsDistributorsGridPluginSettings} />
                : <p> Справочник не настроен</p>
        }
    }
}
